import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "dialog-content",
  ref: "innerRef"
}

import { getCurrentInstance, ref, computed } from 'vue'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'MerchantQualificationDialog',
  props: {
    merchantQualificationDialogShow: {
        type: Boolean,
        default: false
    },
    closable: {
        type: Boolean,
        default: true
    }
},
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const router = useRouter()

const props = __props

const submitBtnDisabled = computed(() => {
    return !agree.value || !isBottom.value || timeCount.value !== 0
})

const dialogShow = ref<boolean>(props.merchantQualificationDialogShow)

const agree = ref<boolean>(false) // 是否已阅读并同意
const isBottom = ref<boolean>(false) // 滚动条是否已到底/用户是否已完全阅读
const scrollerHeight = ref<number>(400) // 滚动内容高度
const scrollBehavior = ({ scrollTop }) => {
    // 获取子容器高度
    const childElHeight = proxy.$refs.innerRef.clientHeight
    // 子容器高度 - 父容器高度 = 可滚动高度
    const scrollableHeight = childElHeight - scrollerHeight.value
    // 判断已滚动距离是否大于等于可滚动高度
    if (scrollTop >= scrollableHeight) {
        isBottom.value = true
    }
}


// 弹框倒计时
const timeCount = ref<number>(10)
let timer = setInterval(() => {
    timeCount.value--
    if (timeCount.value <= 0) {
        clearInterval(timer)
    }
}, 1000)

const onSubmit = () => {
    sessionStorage.setItem('merchant_qualification_dialog', '1') // 添加本地缓存，只有登录时弹一次
    router.push('/qualification/list?incomplete=1')
}

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogShow).value = $event)),
    "close-on-click-modal": false,
    center: "",
    "show-close": __props.closable,
    "z-index": 4000,
    "close-on-press-escape": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_checkbox, {
        modelValue: agree.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((agree).value = $event)),
        label: "我已阅读，并知晓"
      }, null, 8, ["modelValue"]),
      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "color6" }, "平台系统上传，按提示步骤上传文件", -1)),
      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
      _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !agree.value,
        onClick: onSubmit
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" 下一步 ")
        ])),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_scrollbar, {
        height: "60vh",
        onScroll: scrollBehavior
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _cache[2] || (_cache[2] = [
            _createElementVNode("h3", null, [
              _createTextVNode("重要通知"),
              _createElementVNode("br"),
              _createTextVNode("关于完善商户信息")
            ], -1),
            _createElementVNode("p", { style: {"margin-top":"20px"} }, "国家税务总局《互联网平台企业涉税信息报送规定》", -1),
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                href: "https://www.chinatax.gov.cn/chinatax/n810356/n810961/c5237266/content.html",
                target: "_blank"
              }, "https://www.chinatax.gov.cn/chinatax/n810356/n810961/c5237266/content.html")
            ], -1),
            _createElementVNode("p", { style: {"margin-top":"20px","text-indent":"40px"} }, "请阅读：", -1),
            _createElementVNode("img", {
              style: {"width":"100%"},
              src: "https://image-oss.dangaoss.cn/common/common_20250319161405_200.jpg"
            }, null, -1)
          ]), 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "show-close"]))
}
}

})